import { SVGFC } from '@repo/toolkit/types'

const ListApprovedIcon: SVGFC = ({ color, ...props }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M7.19873 15.04L8.11313 16L10.3987 13.6M7.19873 9.44L8.11313 10.4L10.3987 8"
        stroke={color}
        strokeWidth="1.14286"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.8 9.6H16.8M12.8 15.2H16.8M20 12C20 15.7712 20 17.6568 18.828 18.828C17.6576 20 15.7712 20 12 20C8.2288 20 6.3432 20 5.1712 18.828C4 17.6576 4 15.7712 4 12C4 8.2288 4 6.3432 5.1712 5.1712C6.344 4 8.2288 4 12 4C15.7712 4 17.6568 4 18.828 5.1712C19.6072 5.9504 19.868 7.0456 19.956 8.8"
        stroke={color}
        strokeWidth="1.14286"
        strokeLinecap="round"
      />
    </svg>
  )
}

export default ListApprovedIcon
